import { FileText, FileType, Presentation } from 'lucide-react';

import { getFileExtension } from '@/utils/fileUtils';
import { formatFileSize } from '@/utils/formatUtils';

interface MessageFileCardProps {
  filename: string;
  sizeBytes: number;
}

const getFileIcon = (filename: string) => {
  const extension = getFileExtension(filename);

  if (['doc', 'docx'].includes(extension)) {
    return FileType;
  }
  if (extension === 'pptx') {
    return Presentation;
  }
  return FileText;
};

export const MessageFileCard = ({
  filename,
  sizeBytes,
}: MessageFileCardProps) => {
  const Icon = getFileIcon(filename);

  return (
    <div className="flex items-center gap-4 rounded-xl border bg-background pl-4 pr-2 py-2 shadow-xs w-[200px]">
      <div className="flex min-w-0 flex-1 flex-col gap-1">
        <div className="flex items-center gap-2">
          <Icon className="h-4 w-4 shrink-0 text-foreground" />
          <span className="truncate text-sm text-foreground">{filename}</span>
        </div>
        <span className="pl-6 text-xs text-muted-foreground">
          {formatFileSize(sizeBytes)}
        </span>
      </div>
    </div>
  );
};
